import { createSlice } from "@reduxjs/toolkit";

// Initial state for commonSlice reducer
const initialState = {
  allTiers: [],
  appConfigs: [],
};

// Create commonSlice reducer
const commonSlice = createSlice({
  name: "commonSlice",
  initialState,
  reducers: {
    setAllTiers: (state, action) => {
      state.allTiers = action.payload;
    },
    setAppConfigs: (state, action) => {
      state.appConfigs = action.payload;
    },
  },
});

// Export action creators and reducer
export const { setAllTiers, setAppConfigs } = commonSlice.actions;

export default commonSlice.reducer;
